import React from "react";
import { Button, Tooltip } from "@material-ui/core";

import clsx from "clsx";

import PropTypes from "prop-types";
import { useEnqueueSnackbar } from "../../../../hooks/useEnqueueSnackbar";

import useCancellationToken from "../../../../hooks/useCancellationToken";
import apiClient from "../../../../auth/apiClient";

export const UpdateFacilityInfo = ({ entityId }) => {
  const enqueueSnackbar = useEnqueueSnackbar();

  const { execute: updateInfo, inProgress } = useCancellationToken({
    func: async function ({ deviceID, cancelToken }) {
      await apiClient.put(`device/admin/changefacility/${deviceID}`, {
        headers: { "Content-Type": "application/json" },
        cancelToken: cancelToken
      })
    }, errHandleFunc: (err) => {
      enqueueSnackbar('Failed to Request Update Facility Information' + err, {
        variant: "error", tag: "FailedToUpdateFacilityInfo"
      });
    }
  });

  const handleUpdateInfoClick = async () => {
    await updateInfo({ deviceID: entityId });
  };

  return (
      <Tooltip
          arrow
          placement="right"
          title="Send the latest facility ID to the device.  The device must be connected."
      >
        <Button
            className={clsx(["btn-updated-facility"])}
            fullWidth
            variant="contained"
            data-testid="update-facility-btn"
            onClick={handleUpdateInfoClick}
            color="primary"
            disabled={inProgress}
        >
          Update Facility Info
        </Button>
      </Tooltip>
  );
};

UpdateFacilityInfo.defaultProps = {
  entityId: PropTypes.string,
};

UpdateFacilityInfo.propTypes = {
  entityId: PropTypes.string,
};

export default UpdateFacilityInfo;